import Chip from "@mui/material/Chip";
import {getStatusIcon, statusColors} from "./publishStatus";
import {getHrPublishingState} from "./getHrPublishingState";

export const PublishingStatusChip = ({t, status}) => {
    const icon = getStatusIcon(status);
    const backgroundColor = statusColors[status].background;
    const hrLabel = getHrPublishingState(t, '', status, false);
    return <Chip label={hrLabel} sx={{backgroundColor: backgroundColor}} icon={icon}/>;
};
